package one.healthium.insights.data.mapper

import one.healthium.common.mapper.ColorMapper
import one.healthium.insights.data.dto.ContentScreenDto
import one.healthium.insights.data.dto.NavbarDto
import one.healthium.insights.domain.models.ContentPreviewModel
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.models.NabBarStyle
import one.healthium.insights.domain.models.NavbarModel

internal class ContentScreenMapper(
    private val contentMapper: ContentMapper,
    private val colorMapper: ColorMapper,
    private val actionMapper: ActionMapper,
) {
    fun dtoToModel(dto: ContentScreenDto): ContentScreenModel {
        return ContentScreenModel(
            id = dto.id,
            navbar = mapNavbar(dto.navbar),
            preview = dto.preview?.let {
                ContentPreviewModel(
                    title = it.title,
                    description = it.description,
                    thumbUrl = it.thumbUrl,
                )
            },
            content = dto.content.mapNotNull(contentMapper::mapContentEntry),
        )
    }

    private fun mapNavbar(dto: NavbarDto?) = dto?.let {
        NavbarModel(
            title = it.title,
            color = it.color?.let(colorMapper::parseColor),
            style = when (it.style) {
                "large" -> NabBarStyle.Large
                else -> NabBarStyle.Default
            },
            image = it.image,
            actions = it.actions?.mapNotNull(actionMapper::dtoToModel),
        )
    }
}